// extracted by mini-css-extract-plugin
export var active = "_gp-7";
export var blink = "_gp-8";
export var dropDownSelector = "_gp-4";
export var dropDownWrapper = "_gp-3";
export var fakeCursor = "_gp-6";
export var fontSizeButton = "_gp-9";
export var formQuillEditor = "_gp-0";
export var pressed = "_gp-a";
export var qlBlank = "_gp-1";
export var textFormattingToolbar = "_gp-2";
export var textToolbarOption = "_gp-5";